import { render, staticRenderFns } from "./DevicesPage.vue?vue&type=template&id=208f6b1e&scoped=true"
import script from "./DevicesPage.vue?vue&type=script&lang=js"
export * from "./DevicesPage.vue?vue&type=script&lang=js"
import style0 from "./DevicesPage.vue?vue&type=style&index=0&id=208f6b1e&prod&scoped=true&lang=css"
import style1 from "./DevicesPage.vue?vue&type=style&index=1&id=208f6b1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208f6b1e",
  null
  
)

export default component.exports